export default __webpack_public_path__ + "static/media/extra_out_r6.85545bed.svg";